export const colors = {
  // PRIMARY COLORS
  orange: '#f7941d',
  $lightorange: '#f7a54b',
  green: '#8dc63f',
  lightGreen: '#e7f4d3',
  blue: '#27aae1',
  lightBlue: '#d2eff9',
  gray: '#f5f5f5',

  primary: '#547ce6',
  iconColor: '#8dc63f',
  disabledPrimaryColor: 'rgba(84, 124, 230, 0.4)',
  nobel: '#B4B4B4',
  white: '#ffffff',
  black: '#000',
};
